// Components from identity pages (admin surfaces) that are resolved by
// PascalCase string-key within admin page trees. Exported here so they
// land in the shared library component registry and are available in
// workspace-project and any future runner-shell consumer.

export {
  AdminSidebar,
  AdminSidebarLink,
  AdminUserRow
} from '../pages/admin/admin.js'

export {
  AdminLogDay,
  AdminLogGroup,
  AdminLogCalendar,
  AdminLogCalendarCell,
  AdminLogRow
} from '../pages/admin/logs.js'

export { AdminActivityScoringRow } from '../pages/admin/activity-scoring.js'
